import axios from "axios";
import { debugWarn } from "@/lib/debug";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;
// Legacy key: sessions used to be kept in localStorage. They now live in an HttpOnly cookie set by the API,
// so page scripts (and any XSS) can no longer read the token. We only clean the old value up.
const LEGACY_TOKEN_KEY = "tamreer_token";
try { localStorage.removeItem(LEGACY_TOKEN_KEY); } catch (e) { debugWarn("legacy token cleanup skipped (storage unavailable)", e); }

const api = axios.create({
  baseURL: API_BASE,
  timeout: 30000,
  withCredentials: true, // send/receive the session cookie
  headers: { "X-Requested-With": "Tamreer" }, // CSRF marker required by the API for cookie-authenticated writes
});

api.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error?.response?.status === 401) {
      window.dispatchEvent(new Event("tamreer:unauthorized"));
    }
    return Promise.reject(error);
  }
);

/** One FastAPI validation error → "field: message". */
const validationText = (x) => (x.loc ? `${x.loc.slice(-1)[0]}: ${x.msg}` : x.msg || JSON.stringify(x));

/** FastAPI `detail` can be a string, a list of validation errors or an object with `message`. */
function detailText(d) {
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map(validationText).join("; ");
  return typeof d.message === "string" ? d.message : JSON.stringify(d);
}

export function errMsg(error, fallback = "Something went wrong") {
  const d = error?.response?.data?.detail;
  return d ? detailText(d) : error?.message || fallback;
}

/** Same-origin file URL; the browser attaches the session cookie automatically (no token in the URL). */
export function fileUrl(fileId) {
  return `${API_BASE}/files/${fileId}`;
}

export default api;
